import React from 'react';

export const ArrowRight = ({ color = '#181818', ...restProps }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path d="M5 12L19 12" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 5L19 12L12 19"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
